<template>
  <div>
    <list
      row-key="RecordId"
      ref="list"
      unit="仓库管理"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canDel()"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="仓库名称">
          <el-input
            v-model="params.WhName"
            placeholder="请输入仓库名称"
            clearable
          />
        </el-form-item>
        <!-- <el-form-item label="仓库类型">
            <el-select v-model="params.whType" placeholder="请选择仓库类型" clearable>
              <el-option label="一般仓" :value="1"></el-option>
              <el-option label="保税仓" :value="0"></el-option>
            </el-select>
          </el-form-item> -->

        <!-- <el-form-item label="所属商家" prop="StoreId" v-if="loginInfo.UserType==0">
          <busi-select v-model="params.StoreId" ref="busiSelect"></busi-select>
        </el-form-item> -->
        <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column
          prop="OrderId"
          label="序号"
          align="center"
          width="60"
        />

        <!-- <el-table-column
          prop="StoreName"
          label="所属商家"
          v-if="$permission.isStore() == false"
        /> -->
        <el-table-column prop="WhName" label="仓库名称" />
        <el-table-column prop="ContactName" label="联系人" />
        <el-table-column prop="ContactPhone" label="联系电话" />
        <!-- <el-table-column prop="WhType" width="80px" label="仓库类型" align="center">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.WhType == 1">一般仓</el-tag>
              <el-tag type="danger" v-else>保税仓</el-tag>
            </template>
          </el-table-column> -->
        <!-- 
          <el-table-column prop="SyncState" width="80px" label="同步状态" align="center" v-if="loginInfo.UserType == 0">
            <template slot-scope="{row}">
              <el-tag type="success" v-if="row.WhType == 1"></el-tag>
              <el-tag type="success" v-else-if="row.WhType == 0 && row.SyncState == 1">已同步</el-tag>
              <el-tag type="danger" v-else-if="row.WhType == 0 && row.SyncState == 0">未同步</el-tag>
            </template>
          </el-table-column> -->

        <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.State == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import busiSelect from "@/components/shop/business/select";

export default {
  mixins: [listMixin],
  components: { list, busiSelect },
  data() {
    return {
      api: require("@/api/wh/base").default,
      params: {
        WhName: "",
        WhType: "",
        State: null,
      },
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>